import React, { Component } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import XDate from "xdate";
import DomainSelect from "Components/domainSelect/DomainSelect";
import DayPicker from "Components/dayPicker/DayPicker";
import { t } from "i18next";
import Select from "Components/select/Select";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";
import HourPicker from "Components/hourPicker/HourPicker";

import QboxmailApi from "../../qboxmailApi";

import cx from "classnames";
import s from "./etliveFilters.scss";

const ContextTypes = {
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

export default class ETLiveFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      today: new XDate().toDate(),
      oneMonthAgo: new XDate().addMonths(-1).toDate(),
      daysAgo21: new XDate().addDays(-20).toDate(),
      showAdvanced: false,
      selectedMailbox: undefined,
      limitTracemail21Days: undefined,
    };
  }

  toggleAdvancedFields = () => {
    this.setState({ showAdvanced: !this.state.showAdvanced });
  };

  componentDidMount() {
    if (this.props.currentQuery.domain) {
      this.getDomainsEmailAccounts().then((opts) => {
        if (this.props.currentQuery.mailbox) {
          this.setState({
            selectedMailbox: opts.filter((o) => o.value === this.props.currentQuery.mailbox)[0]?.value,
          });
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { currentQuery } = this.props;

    if (prevProps.currentQuery.domain !== currentQuery.domain) {
      this.getDomainsEmailAccounts();
    }

    if (!currentQuery.domain && prevProps.currentQuery.domain) {
      this.setState({ domainEmails: [] });
    }

    if (currentQuery.mailbox != prevProps.currentQuery.mailbox) {
      this.setState({ selectedMailbox: currentQuery.mailbox });
    }

    if (!currentQuery.mailbox && prevProps.currentQuery.mailbox) {
      this.setState({ selectedMailbox: undefined });
    }
  }

  getDomainsEmailAccounts = () => {
    const { currentQuery } = this.props;

    this.setState({ domainEmailsLoading: true });
    const domainCode = currentQuery.domain;
    const client = new QboxmailApi({ useCookie: true });
    return client
      .getDomainsEmailAccounts(domainCode, { per: 9999999, etlive: true, postmaster: true })
      .then((data) => {
        let d = data.resources.map((res) => ({ value: res.code, label: res.name }));

        // if (this.state.initialEmail && !containSelectedEmail) {
        //   retrievedEntries.push(this.state.initialEmail);
        // }

        // this.nextDomainCode = undefined;
        this.setState({ domainEmails: d, domainEmailsLoading: false });
        return d;
      })
      .catch((e) => {
        this.setState({ domainEmailsLoading: false });
        return [];
      });
  };

  formatOptions = (values) => {
    let formattedValues = { ...values };
    const { currentQuery } = this.props;
    if (values.date) {
      formattedValues.date = new XDate(values.date).toString("yyyy-MM-dd");
    }

    const isEditingType = Object.keys(values).includes("type");
    if (isEditingType) {
      currentQuery.action = undefined;
    }

    if (isEditingType && !values.type) {
      _.each(currentQuery, (v, k) => (currentQuery[k] = undefined));
      this.setState({ showAdvanced: false });
    }

    this.props.updateQuery(formattedValues);
  };

  // renderAdvancedFields() {
  //   return (
  //     <div className={s.hourPicker}>
  //       <HourPicker
  //         label={t("input.label.hours.from")}
  //         resettable
  //         name="from"
  //         value={this.props.currentQuery.from}
  //         onChange={this.formatOptions}
  //       />
  //
  //       <HourPicker
  //         label={t("input.label.hours.to")}
  //         resettable
  //         name="to"
  //         value={this.props.currentQuery.to}
  //         onChange={this.formatOptions}
  //       />
  //     </div>
  //   );
  // }

  renderAccessesAdvanced = () => {
    return (
      <Select
        isClearable
        className={s.dynamicSelect}
        label={t("input.label.protocol")}
        components={{ DropdownIndicator }}
        name="protocol"
        options={[
          { value: "all", label: t("select.value.all") },
          { value: "pop3", label: t("select.value.pop") },
          { value: "imap", label: t("select.value.imap") },
          { value: "webmail", label: t("select.value.webmail") },
        ]}
        value={this.props.currentQuery.protocol}
        onChange={this.formatOptions}
      />
    );
  };

  renderMailinsAdvanced = () => {
    return (
      <Select
        isClearable
        className={s.dynamicSelect}
        label={t("input.label.filterBy")}
        components={{ DropdownIndicator }}
        name="filter"
        options={[
          { value: "all", label: t("select.value.all") },
          { value: "spamdyke", label: "Spamdyke" },
          { value: "qmailscanner", label: "Qmailscanner" },
        ]}
        value={this.props.currentQuery.filter}
        onChange={this.formatOptions}
      />
    );
  };

  render() {
    const { className, currentQuery, updateQuery, loggedUserType, loggedUser } = this.props;

    const { isMobileDevice, isMediaMobile, isMediaSM, isMediaMD, isMediaLG } = this.context;

    const hideDomainSelect = loggedUserType === "Postmaster" || loggedUserType === "EmailAccount";
    const hideMailboxSelect = loggedUserType === "EmailAccount";
    const isAdmin = loggedUserType === "Admin";

    return (
      <div
        className={cx(className, s.etliveFilters, {
          [s.showAdvanced]: this.state.showAdvanced,
          [s.isPostmaster]: loggedUserType === "Postmaster",
          [s.isEmailAccount]: loggedUserType === "EmailAccount",
        })}
      >
        <Select
          isClearable
          className={s.type}
          label={t("input.label.action")}
          components={{ DropdownIndicator }}
          name="type"
          options={[
            { value: "accesses", label: t("select.value.accesses") },
            { value: "mailins", label: t("select.value.mail.in") },
            { value: "mailouts", label: t("select.value.mail.out") },
          ]}
          value={currentQuery.type}
          onChange={this.formatOptions}
        />
        {!hideDomainSelect && (
          <DomainSelect
            className={s.domain}
            onChange={(e) => {
              updateQuery(e);
              this.setState({ limitTracemail21Days: e.limit_tracemail_21_days });
            }}
            disabledIf={(domain) => {
              return isAdmin && loggedUser.tracemail_domains_blacklist.includes(domain.name);
            }}
            disabledReason="Accessibile solo al Customer"
            initialValue={currentQuery.domain}
            etlive
          />
        )}

        {!hideMailboxSelect && (
          <Select
            className={s.emailAccount}
            label={t("input.label.account")}
            components={{ DropdownIndicator }}
            name="mailbox"
            isLoading={this.state.domainEmailsLoading}
            isDisabled={!currentQuery.domain || !this.state.domainEmails || this.state.domainEmails.length === 0}
            isClearable
            value={this.state.selectedMailbox}
            options={this.state.domainEmails}
            onChange={updateQuery}
            noOptionsMessage={t("input.placeholder.email.hint")}
          />
        )}

        <DayPicker
          className={s.dayPicker}
          name="date"
          label={t("input.label.date.onDay")}
          value={currentQuery.date || this.state.today}
          maxDate={this.state.today}
          minDate={this.state.limitTracemail21Days && !isAdmin ? this.state.daysAgo21 : this.state.oneMonthAgo}
          onChange={this.formatOptions}
          disabled={!currentQuery.domain}
        />

        <div className={s.showMore} onClick={this.toggleAdvancedFields}>
          {this.state.showAdvanced ? t("button.advanced.filters.hide") : t("button.advanced.filters.show")}
        </div>

        {this.state.showAdvanced && (
          <div className={s.hourPicker}>
            <HourPicker
              className={s.hourPickerFrom}
              label={t("input.label.hours.from")}
              resettable
              name="from"
              value={this.props.currentQuery.from}
              onChange={this.formatOptions}
            />

            <HourPicker
              label={t("input.label.hours.to")}
              resettable
              name="to"
              value={this.props.currentQuery.to}
              onChange={this.formatOptions}
            />
          </div>
        )}
        {/*this.state.showAdvanced && this.renderAdvancedFields()*/}
        {this.state.showAdvanced && this.props.currentQuery.type === "accesses" && this.renderAccessesAdvanced()}
        {this.state.showAdvanced && this.props.currentQuery.type === "mailins" && this.renderMailinsAdvanced()}
      </div>
    );
  }
}

//ETLiveFilters.propTypes = propTypes;
ETLiveFilters.contextTypes = ContextTypes;
